/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Container, Row, Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import { setCurrencyFormat } from '../../../../utils/helpers';


const ViewSalesReportModal = ({ isOpen, handleModal, modalData, tableHeaderData, fileName, title,
    currentlyShow }) => {
    const groupBy = currentlyShow?.value;

    const groupedData = {};

    modalData.forEach((item) => {
        const { salesMonth, salesYear, subscribed, orderCount, amount } = item;
        const currentGroupByKey = item[groupBy];
        const key = `${salesMonth}-${salesYear}-${subscribed}-${currentGroupByKey}`;
        const data = { ...item }
        if (groupedData[key]) {
            groupedData[key].orderCount += Number(orderCount);
            groupedData[key].amount += Number(amount)
        } else {
            data.orderCount = Number(orderCount);
            data.amount = Number(amount)
            groupedData[key] = data
        }
    })

    const data = Object.values(groupedData);
    const excelData = data.map((item) => {
        const updated = { ...item }
        updated.orderCount = setCurrencyFormat(Number(item.orderCount).toFixed(2), false);
        updated.amount = setCurrencyFormat(Number(item.amount).toFixed(2), true)
        return updated
    })

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, `${fileName || "report"}.xlsx`);
    };


    return (
        <Modal
            isOpen={isOpen}
            toggle={() => handleModal(true)}
            style={{ maxWidth: '800px' }}
            className="modal-dialog ltr-support"
            centered
        >
            <div className="modal__header">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={() => handleModal(false)}
                />
                <h4 className="text-modal  modal__title">{title || "Report"}</h4>
                <div className="ExcelTable">
                    <div
                        disabled={!data.length}
                        className="option table-action btn btn-sm"
                        onClick={handleDownload}
                    >
                        Download
                    </div>
                </div>
            </div>
            <div className="modal__body">
                <Row>
                    <ResizableDataTable reactTableData={{ tableHeaderData }} data={data} />
                </Row>
            </div>
        </Modal>
    )
}

ViewSalesReportModal.propTypes = {
    handleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalData: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    title: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired
};

ViewSalesReportModal.defaultProps = {
    fileName: "",
    title: ""
}


export default ViewSalesReportModal;